'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var parts = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون', 'کوادریلیون', 'کویینتیلیون', 'سکستیلیون'];
var numbers = {
  0: ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'],
  1: ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'],
  2: ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'],
  two: ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'],
  zero: 'صفر'
};
var delimiter = ' و ';

function convert(input) {
  var string = input + ''; // covert to string.

  string = string.split('').reverse().join('').replace(/\d{3}(?=\d)/g, '$&,').split('').reverse().join('').split(',').map(function (separated) {
    return Array(4 - separated.length).join('0') + separated;
  });

  var result = [];
  for (var iThree = 0; iThree < string.length; iThree++) {
    var three = string[iThree];
    var resultThree = [];

    for (var index = 0; index < three.length; index++) {
      var digit = three[index];
      if (index === 1 && digit === '1') {
        resultThree.push(numbers.two[three[2]]);
      } else if ((index !== 2 || three[1] !== '1') && numbers[index][digit] !== '') {
        resultThree.push(numbers[index][digit]);
      }
    }

    resultThree = resultThree.join(delimiter);
    result.push(resultThree + ' ' + parts[string.length - iThree - 1]);
  }

  result = result.filter(function (part) {
    return part.trim() !== '';
  }).join(delimiter).trim();

  if (result === '') {
    result = numbers.zero;
  }

  return result;
}

var PersianNumberWords = (function (_Component) {
  _inherits(PersianNumberWords, _Component);

  function PersianNumberWords() {
    _classCallCheck(this, PersianNumberWords);

    _get(Object.getPrototypeOf(PersianNumberWords.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(PersianNumberWords, [{
    key: 'render',
    value: function render() {
      if (typeof this.props.children === 'string') {
        return _react2['default'].createElement(
          'span',
          null,
          convert(this.props.children)
        );
      }
      throw new TypeError('<PersianNumberWords /> Only accepts a single child of type number.');
    }
  }], [{
    key: 'propTypes',
    value: {
      children: _propTypes2['default'].string.isRequired
    },
    enumerable: true
  }]);

  return PersianNumberWords;
})(_react.Component);

exports['default'] = PersianNumberWords;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@thg303/react-persian/lib/PersianNumberWords.js
// module id = 641
// module chunks = 0